import { useEffect, useState } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row, Modal, ModalHeader, ModalBody } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const EvaluationADRBank = props => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [viewPDFModal, setViewPDFModal] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState(null);

  const rowData = list.find(item => item.id === selectedActivityId);

  useEffect(() => {
    (async () => {
      await axios
        .post(
          `${URL.api}activity/activity/listEvaluationsByGroupAdm`,
          {
            private: false,
            group_id: props.general.active_roles.group_id,
            type_id: 6,
            status_id: 2
          },
          {
            headers: { authorization: `Bearer ${props.user.token}` }
          }
        )
        .then(resp => {
          setList(resp.data.data);
        });
    })();
    setLoading(false);
  }, []);

  const errorHandler = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  const viewAction = row => {
    props.history.push(`/activity/show/${row.id}`);
  };

  const printAction = row => {
    setSelectedActivityId(row.id);
    setViewPDFModal(true);
  };

  return (
    <div className="animated fadeIn">
      <Row>
        <Modal isOpen={viewPDFModal} size="md">
          <ModalHeader toggle={() => setViewPDFModal(!viewPDFModal)}>
            PDF da prova
          </ModalHeader>
          <ModalBody>
            {rowData?.file && (
              <button
                className="d-flex border rounded p-0 w-100"
                type="button"
                onClick={() => window.open(rowData.file.link, "_blank")}
              >
                <div className="bg-warning p-3 h-100 rounded-left">
                  <i className="fa fa-file"></i>
                </div>
                <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                  {rowData.file.name}
                </div>
              </button>
            )}
          </ModalBody>
        </Modal>
        <Breadcrumb current={props.currentRoute} />
        {loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            {list ? (
              <div id="list">
                <DataTable
                  list={list}
                  title="Banco de Avaliações ADR"
                  defaultSortOrder="desc"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "description", denomination: "Descrição" },
                    { name: "author", denomination: "Usuário" }
                  ]}
                  action
                  // btnView
                  btnPrint
                  printAction={row => printAction(row)}
                  viewAction={viewAction}
                />
              </div>
            ) : (
              <Loading />
            )}
            <ProtectedRoute routeId={props.currentRoute} />
          </>
        )}
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationADRBank);
